@if (location) {
  <div class="selected-location-icon">
    <app-location-icon [kind]="location.getKind()"></app-location-icon>
  </div>
}
<!-- The model is the search text, which is cleared once a location is picked,
     so `required` is gated on the selection instead — a picked location must
     never read as an error. -->
<p-autocomplete
  [(ngModel)]="searchQuery"
  [suggestions]="locationList"
  (completeMethod)="search($event)"
  (onSelect)="onLocationChange($event)"
  [placeholder]="getPlaceholder()"
  minQueryLength="3"
  [appendTo]="appendTo()"
  [showEmptyMessage]="true"
  [required]="required() && !location"
  [class]="!!location ? 'with-icon' : 'no-icon'"
>
  <ng-template let-location #item>
    <div
      aria-hidden="true"
      class="item-wrapper"
      [class.not-active]="!location.active"
      (click)="!location.active ? $event.stopPropagation() : null"
    >
      @if (location) {
        <app-location-icon [kind]="location.getKind()"></app-location-icon>
      }
      {{ location.getName() }}
      @if (location && location.getKind() === locationKind.airport) {
        <span>, {{ location.getCode() }}</span>
      }
    </div>
  </ng-template>
  <ng-template #empty>
    <app-autocomplete-empty-message
      [loading]="loading()"
      text="Location not found"
    ></app-autocomplete-empty-message>
  </ng-template>
</p-autocomplete>
<div class="filter-info">
  @for (locationKind of locationKindFilterOptions; track locationKind) {
    <app-location-icon
      aria-hidden="true"
      (click)="setLocationKindFilter(locationKind)"
      [class.active]="locationKindFilter === locationKind"
      [kind]="locationKind"
    ></app-location-icon>
  }
  @if (clearFiltersButton()) {
    <i
      aria-hidden="true"
      class="pi pi-ban"
      [class.active]="!!locationKindFilter"
      (click)="clearLocationKindFilter()"
    ></i>
  }
</div>
